import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../utils/translations';
import {Unveil} from '@homeaway/react-unveil';

import './RentalBanner.less';

export class RentalBanner extends React.PureComponent {
    static propTypes = {
        address: PropTypes.string,
        instantBooking: PropTypes.bool.isRequired,
        listingPhoto: PropTypes.string,
        translations: PropTypes.shape({}).isRequired,
    };

    static defaultProps = {
        listingPhoto:
            'http://csvcus.homeaway.com/rsrcs/cdn-logos/2.11.0/bce/brand/misc/property-image-placeholder.svg',
        translations: {},
    };

    render() {
        const {address, instantBooking, translations, listingPhoto} =
            this.props;

        return (
            <Unveil className="RentalBanner" backgroundImage={listingPhoto}>
                {instantBooking ? (
                    <span className="label label-success">
                        {translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.conversation.tripSummary.status.RESERVE'
                        )}
                    </span>
                ) : (
                    <span className="label label-default">
                        {translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.conversation.tripSummary.status.HOLD'
                        )}
                    </span>
                )}
                {address && (
                    <h2 className="text-white RentalBanner__heading">
                        {address}
                    </h2>
                )}
            </Unveil>
        );
    }
}
